import { Flex, Text, tokens } from "shared/components/Spor";

export const InfoContent = () => (
  <Flex direction="column" gap={tokens.default.size.spacing[2]}>
    <Text variant="sm">
      Progresjon for tiltak viser fremdriften for bestillingen av alternativ
      transport – både for hele bruddet og for hvert stoppmønster.
      Stoppmønstrene vises fra start hvis bruddet har et tiltakskort. Uten
      tiltakskort blir de synlige etter de er laget i Status Tiltak.
    </Text>
    <ul style={{ listStyleType: "circle" }}>
      <li>
        <b>Maks behov:</b> Det estimerte behovet for å dekke det maksimale
        passasjerbehovet for hele bruddet.
      </li>
      <li>
        <b>Bestilt:</b> Antall kjøretøy som er bestilt av trafikkplanlegger.
      </li>
      <li>
        <b>Bekreftet:</b> Antall kjøretøy som er bekreftet av leverandørene.
      </li>
      <li>
        <b>Møtt opp:</b> Antall kjøretøy som har registrert oppmøte.
      </li>
    </ul>
    <Text variant="sm" mt={tokens.default.size.spacing[2]}>
      Visningen oppdateres ved endringer i Status Tiltak eller når
      transportselskap bekrefter tilbud eller oppmøte.
    </Text>
  </Flex>
);
